'use strict';

import { ignoreUserRegistrationHook, redirectToUserRegistrationHook, userRegistrationRootState } from './user-registration.states';
import uiRouter from '@uirouter/angularjs';

export const UserRegistrationModule = angular.module('mx.sb.UserRegistration', [uiRouter]).config(userRegistrationConfig);

userRegistrationConfig.$inject = ['$uiRouterProvider', '$transitionsProvider'];
function userRegistrationConfig($uiRouterProvider, $transitions) {
	$uiRouterProvider.stateRegistry.register(userRegistrationRootState);

	$transitions.onBefore({ to: redirectToUserRegistrationHook.condition }, redirectToUserRegistrationHook.hook, redirectToUserRegistrationHook.options);
	$transitions.onBefore({ to: ignoreUserRegistrationHook.condition }, ignoreUserRegistrationHook.hook, ignoreUserRegistrationHook.options);
}
